import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en.js'
import zh from './zh.js'

Vue.use(VueI18n)

const messages = {
	en,
	zh
}

// 从localStorage中读取语言设置，如果没有则使用默认语言
//const savedLocale = localStorage.getItem('language') || 'en'

const i18n = new VueI18n({
	locale: 'en', // 默认语言
	messages
})

export default i18n